import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ManikEntityFE } from '../manik-library/ManikEntityFE';
import { ManikEcomm_LocalDB, IAppMetaData, IEntityMetaDataCollection, IAppMasterData, ICategories, IProducts, Txn_CartMaster, Txn_TabUserContext, Txn_CartItems, ISiteMetaData, IMasterCart, IMyStore, IECommModel } from './IManikEcommBase';
import { map, take, retry } from 'rxjs/operators';
declare const $: any;
export class ManikEcommBase extends ManikEntityFE {
  ManikEcomm_LocalDB: ManikEcomm_LocalDB;
  public OnDemandDivArray: any[] = [];
  SiteMetaData: ISiteMetaData;
  SelectedCartProductHandle: string = "";
  POSInitialized: boolean = false;
  MyStore: IMyStore;
  EcommModel: IECommModel;
  ProductList: IProducts[];

  constructor(public _httpClient: HttpClient) {
    super(document);
    if (sessionStorage.getItem("SiteMetaData")) {
      this.SiteMetaData = JSON.parse(sessionStorage.getItem("SiteMetaData"));
      this.StoreHandle = this.SiteMetaData.StoreHandle;
    }
  }

  PopulateOnlineStore() {
    this.ManikEcomm_LocalDB = new ManikEcomm_LocalDB();
    if (this.Meta_DoesLocalStorageExist()) {
      this.Local_BindProducts();
      this.Local_Cart_View();
    }
    else {
      this.Meta_AppMetaDataSynch(this.SiteMetaData.StoreHandle);
    }
  }

  //#region  Offline Methods Implementation
  Meta_DoesLocalStorageExist(): boolean {
    try {
      let MetaData: ManikEcomm_LocalDB = JSON.parse(localStorage.getItem(this.SiteMetaData.StoreHandle + "_ManikEcomm_LocalDB"));
      if (MetaData) {
        this.ManikEcomm_LocalDB = MetaData;
        return true;
      }
    }
    catch { }

    return false;
  }

  Meta_CreateLocalStorage(Key: string, Value: any): boolean {
    localStorage.setItem(Key, JSON.stringify(Value));
    return true;
  }

  Meta_AppMetaDataSynch(StoreHandle: string) {
    this.updateFilterParams(StoreHandle);
    let headers = { headers: this.prepareAddlQueryHeaders2("SMALLSHOP.META.DATA", "BUSINESS", "ECOMM", "ECOMM2") };
    let AppMetaData = this._httpClient.post<IAppMetaData>(this.EndPoint+"entitymgr", null, headers).pipe(map(value => value), take(1), retry(3));

    AppMetaData.subscribe(data => {
      let AppMetaDataCollection: IEntityMetaDataCollection[] = data.ManikJSon[0].JSon0;

      AppMetaDataCollection.forEach(item => {
        this.ManikEcomm_LocalDB[item.Entity] = data.ManikJSon[0]["JSon" + item.EntityIndex];
        if (item.Entity === "Txn_CurrentDeviceContext") {
          this.ManikEcomm_LocalDB[item.Entity] = this.ManikEcomm_LocalDB[item.Entity][0];
        }
      });

      this.Meta_CreateLocalStorage(StoreHandle + "_ManikEcomm_LocalDB", this.ManikEcomm_LocalDB);

      this.Meta_AppMasterDataSynch(StoreHandle);
    });
  }

  Meta_AppMasterDataSynch(StoreHandle: string) {
    this.updateFilterParams(StoreHandle, this.Meta_DoesLocalStorageExist() ? this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext.SelectedBranchHandle : "");
    let headers = { headers: this.prepareAddlQueryHeaders2("BRANCH.MASTER.DATA", "BUSINESS", "ECOMM", "ECOMM2") };
    let AppMasterData = this._httpClient.post<IAppMasterData>(this.EndPoint+"entitymgr", null, headers).pipe(map(value => value), take(1), retry(3));

    AppMasterData.subscribe(data => {
      let AppMetaDataCollection: IEntityMetaDataCollection[] = data.ManikJSon[0].JSon0;

      AppMetaDataCollection.forEach(item => {
        this.ManikEcomm_LocalDB[item.Entity] = data.ManikJSon[0]["JSon" + item.EntityIndex];
      });

      this.Meta_CreateLocalStorage(StoreHandle + "_ManikEcomm_LocalDB", this.ManikEcomm_LocalDB);

      this.Local_BindProducts();
    });
  }

  Local_BindProducts() {
    let Categories: ICategories[] = [];
    let Products: IProducts[] = this.ManikEcomm_LocalDB.Products;
    let Txn_TabUserContext = this.ManikEcomm_LocalDB.Txn_TabUserContext.find(item => item.TabHandle === this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext.SelectedTabHandle);
    if (Txn_TabUserContext) {
      if (Txn_TabUserContext.SubCategoryCSV) {
        let SubCatIDs: any = Txn_TabUserContext.SubCategoryCSV.split(',');
        Products = this.ManikEcomm_LocalDB.Products.filter(item => item.CategoryID == SubCatIDs.find(ele => ele == item.CategoryID));
      }
      else if (Txn_TabUserContext.CategoryCSV) {
        let CatIDs: any = Txn_TabUserContext.CategoryCSV.split(',');
        Categories = this.ManikEcomm_LocalDB.Categories.filter(item => (item.ParentProductCategoryID == CatIDs.find(ele => ele == item.ParentProductCategoryID))
          || (item.ProdCategoryID == CatIDs.find(ele => ele == item.ProdCategoryID)));
        Products = Products.filter(item => Categories.find(ele => (ele.ProdCategoryID === item.CategoryID || ele.ParentProductCategoryID === item.CategoryID)));
      }

      // if (Txn_TabUserContext.SearchText) {
      //   Products = Products.filter(item => item.ProductName.toLowerCase().includes(Txn_TabUserContext.SearchText.toLowerCase()));
      // }
    }
    let ProductsHtml = "";
    let ProductTemplate = this.getOnDemandDivs().find(item => item.id == 'odECOMM-PRODGRID').html;
    let PrdTemplate: any = null;
    let HeadTailTemplate: any = null;
    try {
      PrdTemplate = ProductTemplate.split("#HEADSIGNATURE#");
      HeadTailTemplate = PrdTemplate[1].split("#TAILSIGNATURE#");
      ProductsHtml += HeadTailTemplate[0];
    }
    catch (e) { }
    let ProdGridTemplate: any = null;
    if (PrdTemplate) {
      ProdGridTemplate = PrdTemplate[0];
    } else {
      ProdGridTemplate = ProductTemplate;
    }
    console.log(ProdGridTemplate);
    Products.forEach(item => {
      if (item.ProductHandle)
        ProductsHtml += ProdGridTemplate.replace(/#PRODUCTHANDLE#/g, item.ProductHandle)
          .replace(/#DISCOUNT#/g, item.DiscountValue ? item.DiscountValue + " " + this.ManikEcomm_LocalDB.StoreInfo.CurrencySymbol : 0)
          .replace(/#PRODUCTNAME#/g, item.ProductName)
          .replace(/#SMARTMEDIA#/g, item.MEDIAURL)
          .replace(/#PRICE#/g, this.ManikEcomm_LocalDB.StoreInfo.CurrencySymbol + " " + item.MRP)
          //.replace(/#VARIANTTEXT#/g, item.VariantText)
          .replace(/#FINALPRICE#/g, this.ManikEcomm_LocalDB.StoreInfo.CurrencySymbol + " " + item.OfferPrice);
      //let sVariantHtml = "";
      // Variants.forEach(v => { if (v.ProductID === item.ProductID) sVariantHtml += "<option value=" + v.CombinationValueID + "_" + item.ProductHandle + " mrp=" + v.MRP + " offerprice=" + v.OfferPrice + " membersofferprice=" + v.MembersOfferPrice + ">" + v.VariantCombinationName + "</option>"; });
      // ProductsHtml = ProductsHtml.replace(/#VARIANTOPTIONS#/g, `<select class="cChooseProdSize">` + sVariantHtml + `</select>`);
    });
    ProductsHtml += HeadTailTemplate ? HeadTailTemplate[1] : "";
    $("#manikecommprodgrid").html(ProductsHtml);
    this.Local_Cart_View();
    //this.HideLoader();
  }

  Local_CartSmartManagePlus(ProductHandle: string) {
    let Txn_CartItems: Txn_CartItems[] = this.ManikEcomm_LocalDB.Txn_CartItems;
    let TabUserContext: Txn_TabUserContext = this.ManikEcomm_LocalDB.Txn_TabUserContext.find(item => item.TabHandle === (this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext.SelectedTabHandle));
    let OnDeviceCartHandle = this.ManikEcomm_LocalDB.Txn_CartMaster.find(i => i.TabHandle === TabUserContext.TabHandle).OnDeviceCartHandle;

    let ExistingProductInCart: any = {};
    if (ProductHandle && Txn_CartItems.length) {
      ExistingProductInCart = Txn_CartItems.filter(item => item.ProductHandle === ProductHandle && item.OnDeviceCartHandle === OnDeviceCartHandle);
    }
    if (ExistingProductInCart.length) {
      ExistingProductInCart[0].Quantity += 1;
      for (let i = 0; i < Txn_CartItems.length; i++) {
        if (Txn_CartItems[i].ProductHandle === ProductHandle && Txn_CartItems[i].OnDeviceCartHandle === OnDeviceCartHandle) {
          ExistingProductInCart[0].LineTotalOnMRP = ((+ExistingProductInCart[0].MRP) * (+ExistingProductInCart[0].Quantity) - (+ExistingProductInCart[0].LineDiscount));
          Txn_CartItems[i] = ExistingProductInCart[0];
        }
      }
    }
    else {
      Txn_CartItems.push(this.Local_CartCreate(ProductHandle));
    }
    this.ManikEcomm_LocalDB.Txn_CartItems = Txn_CartItems;
    this.Meta_CreateLocalStorage(this.StoreHandle + "_ManikEcomm_LocalDB", this.ManikEcomm_LocalDB);
    this.Local_Cart_View(ProductHandle);
  }

  Local_CartSmartManageMinus(ProductHandle: string, Operation: string) {
    var Txn_CartItems: any[] = this.Local_CartSmartManage(ProductHandle, Operation);
    this.ManikEcomm_LocalDB.Txn_CartItems = Txn_CartItems;
    //this.Meta_CreateLocalStorage(this.SiteMetaData.StoreHandle + "_ManikEcomm_LocalDB", this.ManikEcomm_LocalDB);
    this.Local_Cart_View(ProductHandle);
  }

  Local_CartSmartManage(ProductHandle: string, Operation: string): any[] {
    let Txn_CartItems: Txn_CartItems[] = this.Local_CartGetMyCart();
    let ExistingProductInCart: any = {};
    if (Operation === "R" && ProductHandle && Txn_CartItems.length) {
      Txn_CartItems = Txn_CartItems.filter(item => item.ProductHandle !== ProductHandle);
    }
    else if (ProductHandle && Txn_CartItems.length) {
      ExistingProductInCart = Txn_CartItems.filter(item => item.ProductHandle === ProductHandle)[0];
    }

    if (ExistingProductInCart) {
      if (ExistingProductInCart.Quantity <= 1) {
        Txn_CartItems = Txn_CartItems.filter(item => item.ProductHandle !== ProductHandle);
      }
      else {
        ExistingProductInCart.Quantity -= 1;

        for (var i = 0; i < Txn_CartItems.length; i++) {
          if (Txn_CartItems[i].ProductHandle === ProductHandle) {
            ExistingProductInCart.LineTotal = (parseFloat(ExistingProductInCart.MomentPrice) * parseFloat(ExistingProductInCart.Quantity));
            Txn_CartItems[i] = ExistingProductInCart;
          }
        }
      }
    }

    return Txn_CartItems;
  }

  Local_Cart_View(ProductHandle: string = "", Type: string = "") {
    try {
      let Txn_TabUserContext: Txn_TabUserContext = this.ManikEcomm_LocalDB.Txn_TabUserContext.find(item => item.TabHandle === (this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext.SelectedTabHandle));
      let CartItems: Txn_CartItems[] = this.Local_CartGetMyCart();
      let targetControl = this.getOnDemandDivs().find(item => item.id === "odBODY-CART" || item.id === "odECOMM-CART").targetcontrol;
      let CartHtml: any = this.getOnDemandDivs().find(item => item.id === "odBODY-CART" || item.id === "odECOMM-CART").html.split("#PRODUCTSIGNATURE#");
      let oProduct: Txn_CartItems = CartItems ? CartItems.find(item => item.ProductHandle === ProductHandle) : null;
      if (Txn_TabUserContext.TabHandle === "TAB.ONE") {
        this.ManikEcomm_LocalDB.Txn_TabUserContext = [];
        this.ManikEcomm_LocalDB.Txn_CartMaster = this.ManikEcomm_LocalDB.Txn_CartMaster.filter(item => item.TabHandle !== "TAB.ONE" && item.TabHandle);
        this.ManikEcomm_LocalDB.Txn_CartItems = this.ManikEcomm_LocalDB.Txn_CartItems.filter(item => item.OnDeviceCartHandle);
        this.Meta_CreateLocalStorage(this.SiteMetaData.StoreHandle + "_ManikEcomm_LocalDB", this.ManikEcomm_LocalDB);
        this.Local_CartCreateATab();
      }
      if (oProduct) {
        if (oProduct.Quantity > 1) {
          $("#lblItemQty_" + ProductHandle).html(oProduct.Quantity);
          $("#dvFinalPrice_" + ProductHandle).html(oProduct.LineTotalOnMRP - oProduct.LineDiscount);
        }
        else if (Type !== "U") {
          this.Local_InitializeCartInDOM(targetControl, CartHtml[0]);
        }
      }
      else if (Type !== "U") {
        this.Local_InitializeCartInDOM(targetControl, CartHtml[0]);
      }
      //setTimeout(() => {
      let CartProductHtml = "";
      if (CartItems.length) {
        var dSubTotal = 0.00;
        for (var i = 0; i < CartItems.length; i++) {
          dSubTotal += (CartItems[i].MRP * CartItems[i].Quantity);
        }

        if ((!oProduct || oProduct.Quantity === 1) && Type !== "U") {
          CartItems.forEach(item => {
            if (item.Quantity) {
              let sHtml = CartHtml[1];
              CartProductHtml += sHtml.replace(/#MEDIAURL#/g, item.ImageURL)
                .replace(/#PRODUCTHANDLE#/g, item.ProductHandle)
                .replace(/#PRODUCTNAME#/g, item.ProductName)
                .replace(/#QUANTITY#/g, item.Quantity)
                .replace(/#PRICE#/g, item.MRP)
                .replace(/#FINALPRICE#/g, item.LineTotalOnMRP - item.LineDiscount);
            }
          });

          $("#manikproducts").html(CartProductHtml);
        }

        $("#cCartItem-subtotal").html(dSubTotal);
        $("#cManikTotalItemInCart").html(CartItems.length);
        $("#cCartItem-tax").html(dSubTotal * 5 / 100);
        $("#cCartItem-total").html(dSubTotal + (dSubTotal * 5 / 100));
        $("#iManikUpdateFinalPrice_" + ProductHandle).html(dSubTotal);
      }
      else {
        $("#manikproducts").html("");
        $("#cCartItem-subtotal").html(0);
        $("#cManikTotalItemInCart").html(0);
        $("#cCartItem-tax").html(0);
        $("#cCartItem-total").html(0);
      }

      if (targetControl === "manikPopup") {
        $("#myModal").find(".modal-dialog").attr('style', $("#pluginECOMM-CART").attr('popupstyle'));
      }
      else if (targetControl === "ecommWorkspace") {
        // $([document.documentElement, document.body]).animate({
        // scrollTop: $("#manikEcommWorkspace").offset().top
        // }, 500);
      }
      else if (targetControl === "ecommOverlap") {
        var $overlapDiv = $('.manikEcommOverlapRIGHT');
        $overlapDiv.animate({
          top: parseInt($overlapDiv.css('top'), 10) == -400 ?
            0 : -400
        });
      }

      if (ProductHandle) {
        $(".cManikPOSCartItem").removeClass("cCartItem_active");
        $('.cManikPOSCartItem').filter(function () {
          let prdHandle = $(this).attr("producthandle");
          if (prdHandle === ProductHandle) {
            $(this).addClass("cCartItem_active");
          }
        });
      }
      //   else {

      //   }
      // }, 10);
      $("#iManikCartBadge").html(CartItems.length);
      CartItems.length ? $("#iManikEmprtCart_Show").hide() : $("#iManikEmprtCart_Show").show();
      if (!oProduct)
        this.showNotification('top', 'right', 'success', 'successfully added to your cart', CartItems.find(item => item.ProductHandle === ProductHandle).ProductName);
    }
    catch (error) { }

    window['angularComponentRef'].component.oProcessMicroSite.IsProcessing = false;
  }

  Local_InitializeCartInDOM(targetControl: string, CartHtml: string) {
    if (targetControl === "manikPopup") {
      $("#iPopupBody").html(CartHtml);
    }
    else if (targetControl === "ecommWorkspace") {
      $("#manikEcommWorkspace").html(CartHtml);
    }
    else if (targetControl === "ecommOverlap") {
      $('.manikEcommOverlapRIGHT').html(CartHtml);
    }
    else {
      $(".cProductFixedCart").html(CartHtml);
    }
  }

  Local_Update_TabUserContext(TabHandle?: string, TabText?: string) {
    this.Local_InitializeLocalStorage();
    this.ManikEcomm_LocalDB = new ManikEcomm_LocalDB();
    this.Meta_DoesLocalStorageExist();
    if (TabHandle && TabText) {
      this.ManikEcomm_LocalDB.Txn_TabUserContext.find(item => item.TabHandle === TabHandle).TabName = TabText;
    }
    let CategoryCSV = this.ManikEcomm_LocalDB.Txn_TabUserContext.find(item => item.TabHandle === this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext.SelectedTabHandle).CategoryCSV;
    this.ManikEcomm_LocalDB.Txn_TabUserContext.find(item => item.TabHandle === this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext.SelectedTabHandle).SearchText = $("#txtSearchProducts").val();
    CategoryCSV ? this.ManikEcomm_LocalDB.Txn_TabUserContext.find(item => item.TabHandle === this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext.SelectedTabHandle).CategoryCSV += "," + $(".cProductCats-item_active").attr("value") : $(".cProductCats-item_active").attr("value");

    this.Meta_CreateLocalStorage(this.SiteMetaData.StoreHandle + "_ManikEcomm_LocalDB", this.ManikEcomm_LocalDB);
    this.Local_BindProducts();
  }

  Local_EventOnFilterChange(StoreHandle: string, CategoryID: string = "", Type: string = "") {
    let TabUserContext: Txn_TabUserContext = this.ManikEcomm_LocalDB.Txn_TabUserContext.find(item => item.TabHandle === this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext.SelectedTabHandle);
    TabUserContext.SearchText = $("#txtSearchProducts").val();
    if (Type === "SC") {
      TabUserContext.SubCategoryCSV = CategoryID;
    }
    if (Type === "C") {
      TabUserContext.SubCategoryCSV = "0";
      TabUserContext.CategoryCSV = CategoryID ? CategoryID : $(".cManikCategories").val();
    }

    this.ManikEcomm_LocalDB.Txn_TabUserContext.forEach(item => {
      if (item.TabHandle === this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext.SelectedTabHandle) {
        item.SubCategoryCSV = TabUserContext.SubCategoryCSV;
        item.CategoryCSV = TabUserContext.CategoryCSV;
        item.SearchText = TabUserContext.SearchText;
      }
    });
    //this.Meta_CreateLocalStorage(StoreHandle + "_ManikEcomm_LocalDB", this.ManikEcomm_LocalDB);

    //this.Local_BindProducts();

    this.Online_FilterProducts();
  }

  // #region Tab Management

  Local_CartCreateATab(RefreshCart: boolean = false) {
    try {
      this.Local_InitializeLocalStorage();
      var TimeNow = new Date();
      let TabUserContext: Txn_TabUserContext = {
        TabHandle: this.Date_GetYYMMDDhhmmss_DateString(TimeNow),
        TabName: this.getManikDateString(TimeNow),
        BranchHandle: this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext.SelectedBranchHandle,
        SalesPersonHandle: this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext.LoggedInSalesPersonHandle,
      };

      let CartMaster: Txn_CartMaster = {
        TabHandle: TabUserContext.TabHandle,
        OnDeviceCartHandle: this.Local_CreateNewGUID(),
        CurrentCartBatchHandle: this.Local_CreateNewGUID()
      }

      this.ManikEcomm_LocalDB.Txn_CartMaster.push(CartMaster);
      this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext.SelectedTabHandle = TabUserContext.TabHandle;
      this.ManikEcomm_LocalDB.Txn_TabUserContext.push(TabUserContext);
      this.Meta_CreateLocalStorage(this.SiteMetaData.StoreHandle + "_ManikEcomm_LocalDB", this.ManikEcomm_LocalDB);
      if (RefreshCart)
        this.Local_Cart_View();

      $("li").removeClass("active");
      $("div").removeClass("in active");

      let tabHtml = document.createElement("li");
      tabHtml.setAttribute("class", "active");

      let anchor = document.createElement("a");
      anchor.setAttribute("id", "tab_" + TabUserContext.TabHandle);
      anchor.setAttribute("class", "tab_rename");
      anchor.setAttribute("data-toggle", "tab");
      anchor.setAttribute("href", "#" + TabUserContext.TabHandle);
      anchor.textContent = TabUserContext.TabName;

      let input = document.createElement("input");
      input.setAttribute("type", "text");
      input.setAttribute("id", "input_" + TabUserContext.TabHandle);
      input.setAttribute("class", "input_tab");
      input.setAttribute("style", "display:none");

      tabHtml.appendChild(anchor);
      tabHtml.appendChild(input);
      document.getElementById("manikPOSTabsContainer").appendChild(tabHtml);
    }
    catch{ }
  }

  Local_CartPopulateExistingTab() {
    try {
      let TabUserContext: Txn_TabUserContext[] = this.ManikEcomm_LocalDB.Txn_TabUserContext;//.find(item => item.TabHandle === (this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext.SelectedTabHandle));
      if (TabUserContext) {
        TabUserContext.forEach(item => {
          $("li").removeClass("active");
          $("div").removeClass("in active");

          let tabHtml = null;
          tabHtml = document.createElement("li");
          if (item.TabHandle === (this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext.SelectedTabHandle)) {
            tabHtml.setAttribute("class", "active");
          }
          else {
            tabHtml.setAttribute("class", "inactive");
          }

          let anchor = document.createElement("a");
          anchor.setAttribute("id", "tab_" + item.TabHandle);
          anchor.setAttribute("class", "tab_rename");
          anchor.setAttribute("data-toggle", "tab");
          anchor.setAttribute("href", "#" + item.TabHandle);
          anchor.textContent = item.TabName;

          let input = document.createElement("input");
          input.setAttribute("type", "text");
          input.setAttribute("id", "input_" + item.TabHandle);
          input.setAttribute("class", "input_tab");
          input.setAttribute("style", "display:none");

          tabHtml.appendChild(anchor);
          tabHtml.appendChild(input);
          document.getElementById("manikPOSTabsContainer").appendChild(tabHtml);
        });
      }
    }
    catch{

    }
  }
  // #endregion 

  // #region Cart Management

  Local_CartGetMyCart(): Txn_CartItems[] {
    let Txn_TabUserContext: Txn_TabUserContext = this.ManikEcomm_LocalDB.Txn_TabUserContext.find(item => item.TabHandle === (this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext.SelectedTabHandle));
    if (this.ManikEcomm_LocalDB.Txn_CartItems.length) {
      if (this.ManikEcomm_LocalDB.Txn_CartItems[0].ProductHandle) {
        let OnDeviceCartHandle = this.ManikEcomm_LocalDB.Txn_CartMaster.find(i => i.TabHandle === Txn_TabUserContext.TabHandle).OnDeviceCartHandle;
        return this.ManikEcomm_LocalDB.Txn_CartItems.filter(item => item.OnDeviceCartHandle === OnDeviceCartHandle);
      }
    }

    return [];
  }

  Local_CartCreate(ProductHandle: string): Txn_CartItems {
    let TabUserContext: Txn_TabUserContext = this.ManikEcomm_LocalDB.Txn_TabUserContext.find(item => item.TabHandle === (this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext.SelectedTabHandle));
    let CartMaster: Txn_CartMaster = this.ManikEcomm_LocalDB.Txn_CartMaster.find(item => item.TabHandle === TabUserContext.TabHandle);

    let oProductData: IProducts = this.ManikEcomm_LocalDB.Products.find(item => item.ProductHandle === ProductHandle);
    let oCartProduct: Txn_CartItems = {
      OnDeviceCartHandle: CartMaster.OnDeviceCartHandle,
      CartBatchHandle: CartMaster.CurrentCartBatchHandle,
      ProductHandle: oProductData.ProductHandle,
      ProductName: oProductData.ProductName,
      CombinationName: "",
      VariantID: 0,
      CombinationValueID: 0,
      MRP: oProductData.MRP,
      OfferPrice: oProductData.OfferPrice,
      MembersOfferPrice: oProductData.MembersOfferPrice,
      SplDiscountCode: "",
      FinalAppliedPrice: 0,
      ImageURL: oProductData.MEDIAURL,
      CalculatedProductName: "",
      CustomizationRemark: "",
      CustomizationMediaURL: "",
      RequestedDeliveryDate: "",
      RequestedDeliveryTime: "",
      IsTaxInclusive: "",
      Quantity: 1,
      TaxAmount: 0,
      LineTotalOnMRP: oProductData.MRP,
      LineDiscount: 0,
      LineTotalOnOfferPrice: 0,
      LineTotalOnMembersOfferPrice: 0,
      LineSplCalculationHandle: 0,
      LocalUpdateTimestamp: this.getManikDateString(new Date()),
      CalcFunda: ""
    };

    return oCartProduct;
  }

  Local_CartCreateACartBatch() {

  }

  Local_EventOnTabChange(CurrentTabHandle: string) {
    this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext.SelectedTabHandle = CurrentTabHandle;
    this.Meta_CreateLocalStorage(this.SiteMetaData.StoreHandle + "_ManikEcomm_LocalDB", this.ManikEcomm_LocalDB);
    this.Local_Cart_View();
  }

  // #endregion 

  Local_CreateNewGUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  Local_InitializeLocalStorage() {
    this.SiteMetaData = JSON.parse(sessionStorage.getItem("SiteMetaData"));
    this.Meta_DoesLocalStorageExist();
  }

  getOnDemandDivs() {
    return window['angularComponentRef'].zone.run(() => window['angularComponentRef'].component.OnDemandDivArray);
  }

  Local_CalculateTotalItemsInCart(Txn_CartItems: Txn_CartItems[]): number {
    let iTotalitems = 0;
    Txn_CartItems.forEach(item => {
      iTotalitems += item.Quantity;
    });

    return iTotalitems;
  }

  Local_CalculateTotalCartValue(Txn_CartItems: Txn_CartItems[]): number {
    let iTotalValue = 0;
    Txn_CartItems.forEach(item => {
      iTotalValue += (item.LineTotalOnMRP - item.LineDiscount);
    });

    return iTotalValue;
  }

  Local_CalculateTotalSavingOnCart(Txn_CartItems: Txn_CartItems[]): number {
    let iTotalSavings = 0;
    Txn_CartItems.forEach(item => {
      if (item.LineDiscount)
        iTotalSavings += item.LineDiscount;
    });

    return iTotalSavings;
  }

  Date_GetYYMMDDhhmmss_DateString(date: Date) {
    return date.getFullYear().toString() + ConvertTimeStampToNumber(date.getMonth() + 1) + ConvertTimeStampToNumber(date.getDate()) + ConvertTimeStampToNumber(date.getHours()) + ConvertTimeStampToNumber(date.getMinutes()) + ConvertTimeStampToNumber(date.getSeconds());
    function ConvertTimeStampToNumber(n) { return n < 10 ? '0' + n : n }
  }

  //#endregion

  //#region Online Methods Implementation

  API_Checkout() {
    let TabUserContext: Txn_TabUserContext = this.ManikEcomm_LocalDB.Txn_TabUserContext.find(item => item.TabHandle === (this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext.SelectedTabHandle));
    let OnDeviceCartHandle = this.ManikEcomm_LocalDB.Txn_CartMaster.find(i => i.TabHandle === TabUserContext.TabHandle).OnDeviceCartHandle;
    let Txn_CartItems: Txn_CartItems[] = this.ManikEcomm_LocalDB.Txn_CartItems.filter(item => item.OnDeviceCartHandle === OnDeviceCartHandle);

    /* Start Creating Cart Master JSON to send on server for further processing */

    let MasterCart: IMasterCart = {
      CartSummary: {
        StoreHandle: this.SiteMetaData.StoreHandle,
        BuyerHandle: TabUserContext.BuyerHandle,
        SalesPersonHandle: TabUserContext.SalesPersonHandle,
        TabHandle: TabUserContext.TabHandle,
        OnDeviceCartHandle: OnDeviceCartHandle,
        DeliveryAddressID: "0",
        StorePriceListID: "0",
        CouponCode: "",
        CalcFunda: "",
        TotProducts: Txn_CartItems.length,
        TotItems: this.Local_CalculateTotalItemsInCart(Txn_CartItems),
        TotValue: this.Local_CalculateTotalCartValue(Txn_CartItems),
        TotSavings: this.Local_CalculateTotalSavingOnCart(Txn_CartItems),
        Latitude: this.SiteMetaData.BizLatitude,
        Longitude: this.SiteMetaData.BizLongitude,
        ExpirationDate: "",
        LastUpdateSourceID: ""
      },
      CartItems: Txn_CartItems
    }

    /* Ends Creating Cart Master JSON */


    const headers = new HttpHeaders({
      'EntityActionType': 'START.CHECKOUT',
      'BusinessHandle': this.SiteMetaData.BizHandle,
      'StoreHandle': this.SiteMetaData.StoreHandle,
      'BuyerHandle': 'ANONYMOUS',
      'ClientAppHandle': OnDeviceCartHandle,
      'BizDS': this.SiteMetaData.PC,
      'LgContext': 'ECOMM',
      'ECommServer': this.SiteMetaData.ECommServer,
      'PortalContext': this.SiteMetaData.PC,
      'BookingServer': 'BOOKING2'
    });
    // let Payload: any = JSON.stringify(MasterCart);
    let Checkout = this._httpClient.post<any>(this.AppRootUrl + "WebSite/checkout", MasterCart, { headers: headers }).pipe(map(value => value), take(1), retry(3));

    Checkout.subscribe(data => {
      let targetControl = this.getOnDemandDivs().find(item => { return item.id === 'odBODY-CART' || item.id === 'odECOMM-CART' }).targetcontrol;
      if (targetControl === "manikPopup") {
        $("#myModal").modal('toggle');
      }
      // const dialogRef = this._dialog.open(CheckoutComponent, {
      //     maxWidth: '100vw',
      //     maxHeight: '100vh',
      //     width: '95vw',
      //     height: '90vh',
      //     data: {
      //         CheckoutURI: "http://localhost:4242/ecomm/" + data.ManikJSon[0].JSon0[0].ActiveSessionHandle
      //"http://checkout.instaciti.com/ecomm/" + data.ManikJSon[0].JSon0[0].ActiveSessionHandle
      //     }
      // });
      // dialogRef.afterClosed().subscribe(result => {
      // alert('Hello');
      //Make A Call to identify if order was successfully placed then clear the local Cart
      //});
      var winFeature = 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes';
      let checkout = window.open("https://checkout.instaciti.com/ecomm/" + data.ManikJSon[0].JSon0[0].ActiveSessionHandle, "null", winFeature);
      //"toolbar=no,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400");
    });
  }

  Online_FetchStoreInformation() {  
    this.ManikEcomm_LocalDB = new ManikEcomm_LocalDB();
    this.SiteMetaData = JSON.parse(sessionStorage.getItem("SiteMetaData"));
    this.updateFilterParams(this.SiteMetaData.StoreHandle);
    let headers = { headers: this.prepareAddlQueryHeaders2("ONLINE.MYSTORE", "BUSINESS", "ECOMM") };
    let StoreInfo = this._httpClient.post<any>( this.EndPoint+"entitymgr", null, headers).pipe(map(value => value), take(1), retry(3));
    StoreInfo.subscribe(data => {
      this.MyStore = data;
      this.ManikEcomm_LocalDB.StoreInfo = this.MyStore.ManikJSon[0].JSon0[0];
      this.Online_FetchTransactionModel();
    });
  }

  Online_FetchTransactionModel() {
    //this.updateFilterParams(this.StoreHandle);
    let headers = { headers: this.prepareAddlQueryHeaders2("ONDEVICE.TXNMODELS", "BUSINESS", "ECOMM") };
    let StoreInfo = this._httpClient.post<any>(this.EndPoint+"entitymgr", null, headers).pipe(map(value => value), take(1), retry(3));
    StoreInfo.subscribe(data => {
      this.EcommModel = data;
      this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext = this.EcommModel.ManikJSon[0].JSon0[0];
      this.ManikEcomm_LocalDB.Txn_TabUserContext = this.EcommModel.ManikJSon[0].JSon1;
      this.ManikEcomm_LocalDB.Txn_CurrentDeviceContext.SelectedTabHandle = this.ManikEcomm_LocalDB.Txn_TabUserContext[0].TabHandle;
      this.ManikEcomm_LocalDB.Txn_CartMaster = this.EcommModel.ManikJSon[0].JSon2;
      this.ManikEcomm_LocalDB.Txn_CartItems = this.EcommModel.ManikJSon[0].JSon3;
      this.Online_FetchMasterData();
    });
  }

  Online_FetchMasterData() {
    this.updateFilterParams(this.MyStore.ManikJSon[0].JSon1[0].BranchHandle);
    let headers = { headers: this.prepareAddlQueryHeaders2("OUTLET.MASTER.DATA", "BUSINESS", "ECOMM") };
    let StoreInfo = this._httpClient.post<any>(this.EndPoint+"entitymgr", null, headers).pipe(map(value => value), take(1), retry(3));
    StoreInfo.subscribe(data => {
      let d = data;
      console.log(d);
      this.Online_FetchCategories();
    });
  }

  Online_FetchCategories() {
    this.SiteMetaData = JSON.parse(sessionStorage.getItem("SiteMetaData"));
    
    const headers = new HttpHeaders({
      'BusinessSlug': this.SiteMetaData.BizHandle,
      'context': 'COOK.MY.EFFECT',
      'Param1': this.MyStore.ManikJSon[0].JSon1[0].BranchHandle,
      'Param2': 'ECOMM',
      'Param3': 'CATEGORY'
    });

    let Categories = this._httpClient.post<string>("http://sitefetch.manikworks.com/smartbiz", null, { headers: headers }).pipe(map(value => value), take(1), retry(3));
    Categories.subscribe(item => {
      $("#manikecommcategeory").html(item);
    });
    this.Online_FetchProducts();
  }

  Online_FetchProducts() {
    this.updateFilterParams(this.MyStore.ManikJSon[0].JSon1[0].BranchHandle);
    let headers = { headers: this.prepareAddlQueryHeaders2("OUTLET.PRODUCTS", "BUSINESS", "ECOMM") };
    let StoreInfo = this._httpClient.post<any>(this.EndPoint+"entitymgr", null, headers).pipe(map(value => value), take(1), retry(3));
    StoreInfo.subscribe(data => {
      this.ProductList = data.ManikJSon[0].JSon1;
      this.ManikEcomm_LocalDB.Products = this.ProductList;
      this.Local_BindProducts();
    });
  }

  Online_FilterProducts() {
    this.updateFilterParams(this.MyStore.ManikJSon[0].JSon1[0].BranchHandle);
    let headers = { headers: this.prepareManageHeaders2("PRODUCT.SEARCH", "ECOMM.SEARCH", "ECOMM") };
    let StoreInfo = this._httpClient.post<any>(this.EndPoint+"entitymgr", JSON.stringify({ "items": this.ManikEcomm_LocalDB.Txn_TabUserContext }), headers).pipe(map(value => value), take(1), retry(3));
    StoreInfo.subscribe(data => {
      this.ProductList = data.ManikJSon[0].JSon0;
      this.ManikEcomm_LocalDB.Products = this.ProductList;
      this.Local_BindProducts();
    });
  }
  //#endregion
}
